import formsEventsController from '../../../../../../execution/formsEvents/formsEventsController';
import { TFieldValue } from './resolveResponseResult';

export const getSortedForms = (
  filledFormsMap: Record<string, Record<string, TFieldValue>>,
): string[] => {
  return Object.keys(filledFormsMap).sort((a, b) => {
    const { sortedForms } = formsEventsController;
    const formA = window.ApiaFunctions.getForm(a);
    const formB = window.ApiaFunctions.getForm(b);
    if (!formA) return -1;
    if (!formB) return 1;
    if (formA && formB) {
      const aFormPosition = sortedForms.indexOf(formA.frmId as string);
      const bFormPosition = sortedForms.indexOf(formB.frmId as string);
      if (aFormPosition !== bFormPosition) return aFormPosition - bFormPosition;
    }
    return 0;
  });
};
